import LocalizedStrings from "react-localization";

import en from "./en.json";
import ar from "./ar.json";
import sp from "./sp.json"
let strings = new LocalizedStrings({en: en, ar: ar, sp:sp});

export default strings;
